export const MODULE_CLE_TYPE_OPTIONS = [
    { value: "FORMATION", label: "Formation" },
    { value: "ONBOARDING", label: "Onboarding" },
    { value: "SKILLS", label: "Compétences" },
];

export const MODULE_SECTION_STATUS_OPTIONS = [
    { value: "ACTIF", label: "Actif" },
    { value: "INACTIF", label: "Inactif" },
    { value: "ARCHIVE", label: "Archivé" },
];

export const MODULE_CLE_CONTENT_GROUP_OPTIONS = [
    { value: "DOCUMENTS", label: "Documents" },
    { value: "ARTICLE", label: "Article" },
    { value: "RESSOURCES", label: "Ressources" },
];

export const MODULE_CLE_CONTENT_TYPE_OPTIONS_BY_GROUP = {
    DOCUMENTS: [
        { value: "PDF", label: "PDF" },
        { value: "WORD", label: "Word" },
        { value: "EXCEL", label: "Excel" },
        { value: "PPT", label: "PowerPoint" },
        { value: "VIDEO", label: "Vidéo" },
        { value: "IMAGE", label: "Image" },
        { value: "SCORM", label: "SCORM" },
        { value: "LIEN_EXTERNE", label: "Lien externe" },
    ],
    ARTICLE: [{ value: "ARTICLE", label: "Article" }],
    RESSOURCES: [
        { value: "EVALUATION", label: "Évaluation" },
        { value: "QUIZ", label: "Quiz" },
        { value: "EVENEMENT", label: "Événement" },
        { value: "CERTIFICAT", label: "Certificat" },
    ],
};

export const MODULE_CLE_CONTENT_TYPE_OPTIONS = Object.values(MODULE_CLE_CONTENT_TYPE_OPTIONS_BY_GROUP).flat();
export const FILE_CONTENT_TYPES = ["PDF", "WORD", "EXCEL", "PPT", "VIDEO", "IMAGE", "SCORM"];
export const RELATION_CONTENT_TYPES = ["EVALUATION", "QUIZ", "EVENEMENT", "CERTIFICAT"];
export const MODULE_CLE_CONTENT_UNLOCK_MODE_OPTIONS = [
    { value: "BY_DATE", label: "Par date" },
    { value: "BY_PERIOD", label: "Par période" },
    { value: "BY_PREVIOUS_CONTENT", label: "Par contenu précédent" },
];

export const getModuleCleTypeLabel = (value) =>
    MODULE_CLE_TYPE_OPTIONS.find((item) => item.value === value)?.label || value || "Non défini";

export const getModuleSectionStatusLabel = (value) =>
    MODULE_SECTION_STATUS_OPTIONS.find((item) => item.value === value)?.label || value || "Actif";

export const getModuleCleContentTypeLabel = (value) =>
    MODULE_CLE_CONTENT_TYPE_OPTIONS.find((item) => item.value === value)?.label || value || "Non défini";

export const getModuleCleContentUnlockModeLabel = (value) =>
    MODULE_CLE_CONTENT_UNLOCK_MODE_OPTIONS.find((item) => item.value === value)?.label || "Déblocage immédiat";

export const getModuleCleContentGroupFromType = (type) => {
    if (type === "ARTICLE") return "ARTICLE";
    if (RELATION_CONTENT_TYPES.includes(type)) return "RESSOURCES";
    return "DOCUMENTS";
};

export const getContentSourcePreview = (content) => {
    if (!content) return "-";
    if (FILE_CONTENT_TYPES.includes(content.contentType)) return content.fileName || "Fichier";
    if (content.contentType === "ARTICLE") return "Article saisi dans l'application";
    if (content.contentType === "LIEN_EXTERNE") return content.externalUrl || "Lien externe";
    if (content.contentType === "EVALUATION") return content.evaluationLabel || "Évaluation liée";
    if (content.contentType === "QUIZ") return content.quizLabel || "Quiz lié";
    if (content.contentType === "EVENEMENT") return content.evenementLabel || "Événement lié";
    if (content.contentType === "CERTIFICAT") return content.certificatLabel || "Certificat lié";
    return "-";
};

const formatDateTime = (value) => {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const getUnlockRuleSummary = (content) => {
    if (!content?.unlockMode) return "Disponible sans contrainte de déblocage.";

    if (content.unlockMode === "BY_DATE") {
        return content.unlockDate
            ? `Déblocage le ${formatDateTime(content.unlockDate)}`
            : "Déblocage par date non renseigné";
    }

    if (content.unlockMode === "BY_PERIOD") {
        const start = content.unlockStartDate ? formatDateTime(content.unlockStartDate) : "-";
        const end = content.unlockEndDate ? formatDateTime(content.unlockEndDate) : "-";
        return `Déblocage du ${start} au ${end}`;
    }

    if (content.unlockMode === "BY_PREVIOUS_CONTENT") {
        return content.prerequisiteContentTitle
            ? `Après le contenu : ${content.prerequisiteContentTitle}`
            : "Déblocage après un contenu précédent";
    }

    return "Disponible sans contrainte de déblocage.";
};

export const reorderContentsLocally = (list, draggedId, targetId) => {
    const draggedIndex = list.findIndex((item) => item.id === draggedId);
    const targetIndex = list.findIndex((item) => item.id === targetId);
    if (draggedIndex < 0 || targetIndex < 0 || draggedIndex === targetIndex) {
        return list;
    }

    const next = [...list];
    const [draggedItem] = next.splice(draggedIndex, 1);
    next.splice(targetIndex, 0, draggedItem);
    return next.map((item, index) => ({ ...item, ordre: index + 1 }));
};
